import { emptyRules, } from "@shared";
import { addLookedUpMembers } from "../members";
// all of this stuff gets updated together so the whole thing will be a store, but the individual bits don't need to be
// I *think*
export class CommunityDetailsState {
    communityId;
    timestamp;
    userGroups;
    members;
    blockedUsers;
    lapsedMembers;
    invitedUsers;
    referrals;
    bots;
    rules;
    moreMembersAfter;
    constructor(communityId, timestamp, userGroups, members, blockedUsers, lapsedMembers, invitedUsers, referrals, bots, rules = emptyRules(), 
    // Set if not all of the members are held, to the user id after which those not in the
    // first page start
    moreMembersAfter = undefined) {
        this.communityId = communityId;
        this.timestamp = timestamp;
        this.userGroups = userGroups;
        this.members = members;
        this.blockedUsers = blockedUsers;
        this.lapsedMembers = lapsedMembers;
        this.invitedUsers = invitedUsers;
        this.referrals = referrals;
        this.bots = bots;
        this.rules = rules;
        this.moreMembersAfter = moreMembersAfter;
    }
    // These details with members added who have been looked up, or undefined if there are none to
    // add (see `addLookedUpMembers`)
    withLookedUpMembers(found, asOf) {
        const added = addLookedUpMembers(this, found, asOf);
        if (added === undefined) {
            return undefined;
        }
        return new CommunityDetailsState(this.communityId, this.timestamp, this.userGroups, added.members, this.blockedUsers, added.lapsedMembers, this.invitedUsers, this.referrals, this.bots, this.rules, this.moreMembersAfter);
    }
}
